const FiltradoData = ( campos,filtros,general,data) =>{
    let filtrosActivos=false;
    for (const key in filtros) 
      if(filtros[key]!=="")
      {
        filtrosActivos=true;
        break;
      }
    if( filtrosActivos||general!=""){
      
      
      let temporal = [];
      data.map( ( condominio, index ) => {
        let coincide=true;
        let concideGeneral=false;
        for(let campo of campos){
          if (filtros[campo]&&!(condominio[campo]+"").toUpperCase().includes((filtros[campo]+"").toUpperCase()) ) {  
            coincide=false;
            break;
          }
          if(general==''||(condominio[campo]+"").toUpperCase().includes(general.toUpperCase()) )
            concideGeneral=true;
        }
        if(coincide&&concideGeneral)
          temporal.push(condominio)
      });
      return temporal;

    }else{
      return data;
    }    
}
export default FiltradoData;